import { defineMessages } from 'react-intl';

export default defineMessages({
    // add string ids and default values for localization here
    scQuoteValidityDays: {
        id: 'quoteandbind.views.psp.quote.Quote Validity Days',
        defaultMessage: 'THIS QUOTE IS VALID FOR {quoteValidityDays} DAYS - COVERAGE IS NOT BOUND UNTIL A BINDER IS ISSUED',
    },
    covAccordion: {
        id: 'quoteandbind.PSCSpeLinLinedirectives.templates.Success.Coverages',
        defaultMessage: 'Coverages'
    }
});
